import React from 'react';
import { PropTypes } from '../../../utils/propTypes';
import styles from './Label.module.css';

/**
 * Label — a shadcn-style label primitive, reimplemented in Athena's idiom
 * (JSX + CSS Module + 2.0 tokens). Styled with `--field-label-*` tokens.
 * `asChild` merges the label styling/props onto a single child element (so
 * FieldLabel can wrap a nested Field for "choice card" rows). Preview-only for
 * now (globals.css isn't imported into the app).
 */
const Label = ({ asChild = false, className = '', children, ...props }) => {
  const cls = `${styles.label} ${className}`.trim();
  if (asChild && React.isValidElement(children)) {
    return React.cloneElement(children, {
      className: `${cls} ${children.props.className ?? ''}`.trim(),
      ...props,
    });
  }
  return (
    <label data-slot="label" className={cls} {...props}>
      {children}
    </label>
  );
};

Label.propTypes = {
  asChild: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.node,
};

export default Label;
export { Label };
